import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-qr-scanned",
  "use": "icon-qr-scanned-usage",
  "viewBox": "0 0 110 110",
  "content": "<symbol viewBox=\"0 0 110 110\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-qr-scanned\">\n  <rect width=\"110\" height=\"110\" rx=\"55\" fill=\"#00BC6D\" fill-opacity=\"0.2\" />\n  <path d=\"M31.042 57.7969L44.4153 71.1703C44.9216 71.6766 45.7317 71.6766 46.2379 71.1703L78.9586 38.4497\" stroke=\"#00BC6D\" stroke-width=\"5.90625\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol